import React, { useState, useEffect, lazy, Suspense } from 'react'
import { Redirect, BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import { ToastContainer } from 'mdbreact'
//import component
import LoadingScreen from './pages/LoadingScreen'
import LoginPopup from './components/Routes/LoginPopup'
import { notify } from "./components/common/M2WEBNotify"

const Logout = lazy(() => import('./pages/Logout.js'))
const Login = lazy(() => import('./pages/Login.js'))
const ReservationData = lazy(() => import('./pages/ReservationData'))
const ReservationEntry = lazy(() => import('./pages/ReservationEntry'))
const ReservationPeriod = lazy(() => import('./pages/ReservationPeriod'))
const ChangePassword = lazy(() => import('./pages/ChangePassword'))
const ForgotPassword = lazy(() => import('./pages/ResetPassword'))
const NotFound = lazy(() => import('./pages/NotFound'))
const RedirectPage = lazy(() => import('./pages/RedirectPage'))
const UserEditor = lazy(() => import('./pages/UserEditor'))
const LineSubscription = lazy(() => import('./pages/LineSubscription'))
const ReservationEditor = lazy(() => import('./pages/ReservationEditor'))
const Maintenance = lazy(() => import("./pages/Maintenance"))
const RequestResetPassword = lazy(() => import("./pages/RequestResetPassword"))
const ResetPassword = lazy(() => import("./pages/ResetPassword"))
const QueueBookingResult = lazy(() => import("./pages/QueueBookingResult"))

const Routes = () => {
	const [loginPopupVisible, setLoginPopupVisible] = useState(false)
	const [lastTimeAction, setLastTimeAction] = useState(new Date())

	const toggle = () => {
		setLoginPopupVisible(false)
		const newLastTimeAction = new Date()
		setLastTimeAction(newLastTimeAction)
	}

	const handleLoginTime = () => {
		const pathName = window.location.pathname.toLowerCase()
		const exceptionalPaths = ['/login', '/requestresetpassword', '/resetpassword']
		if (exceptionalPaths.includes(pathName)) {
			setLoginPopupVisible(false)
			return
		}

		if (loginPopupVisible)
			return

		const token = localStorage.getItem('token')
		if (!token) {
			window.location.reload()
		}

		const isTimeOut = getIsTimeOut()
		if (isTimeOut) {
			setLoginPopupVisible(true)
			setTimeout(() => {
				clearLocalstorage()
			}, 1000)
		}
	}

	const getIsTimeOut = () => {
		const currentTimeAction = new Date()
		const diff = currentTimeAction - lastTimeAction
		return diff >= parseInt(process.env.REACT_APP_ACTION_TIME_SEC) * 1000
	}

	const clearLocalstorage = () => {
		try {
			localStorage.removeItem('token')
		} catch (err) {
			notify('error', `Error on clearLocalstorage function`)
		}
	}

	return <div
		onMouseMove={handleLoginTime}
		onTouchStart={handleLoginTime}
	>
		<Router>
			<Suspense fallback={<LoadingScreen />}>
				<Switch>
					<PrivateRoute path='/reservationData' component={ReservationData} />
					<PrivateRoute path='/reservationEntry' component={ReservationEntry} />
					<PrivateRoute path='/reservationPeriod' component={ReservationPeriod} />
					<PrivateRoute path='/queue' component={ReservationEditor} />
					<PrivateRoute path='/user' exact component={UserEditor} />
					<PrivateRoute path='/lineSubscription' component={LineSubscription} />
					<PrivateRoute path='/changePassword' component={ChangePassword} />
					<PrivateRoute path='/queueBookingResult' component={QueueBookingResult} />
					{/* <PrivateRoute path='/' exact component={NotFound} /> */}
					<Route path='/logout' component={Logout} />
					<Route path='/login' component={Login} />
					<Route path='/forgottenPassword' component={ForgotPassword} />
					<Route path='/maintenance' component={Maintenance} />
					<Route path='/requestResetPassword' component={RequestResetPassword} />
					<Route path='/resetPassword' component={ResetPassword} />
					<Route path='/' component={RedirectPage} />
				</Switch>
			</Suspense>
			<ToastContainer autoClose={5000} />
			{
				loginPopupVisible && <LoginPopup isOpen={loginPopupVisible} toggle={toggle} />
			}
		</Router>
	</div>
}

const PrivateRoute = ({ component: Component, ...rest }) => {
	const token = localStorage.getItem('token')

	return <>
		<Route {...rest} render={(props) => (
			token ? <Component {...props} /> : <Redirect to='/login' />
		)} />
	</>
}

export default Routes
